// LIBRARIES
import styled from "styled-components";

//MISC

import { MARGIN, DEVICE_TYPE, SIZE } from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const OfficialAnnouncementsContainer = styled.div`
  width: 100%;
  margin-top: 100px;
  padding: 0px 228px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    padding: 0px 128px;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0px 24px;
  }
`;

export const BackToGuidesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 64px;
  width: 200px;
  margin-bottom: ${MARGIN.max10};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  opacity: 0.5;
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.8;
    transition: 0.3s ease-in-out;
  }
`;

export const BackToGuidesImage = styled.img`
  margin-top: 4px;
  margin-right: 8px;
  width: 10px;
  height: 16px;
`;

export const BackToGuidesButton = styled.div`
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: ${MARGIN.fix24};
`;

export const ImgStyled = styled.img``;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 44px;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    margin-bottom: 24px;
  }
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: ${DEVICE_TYPE.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${DEVICE_TYPE.mobile}) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 24px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-bottom: 16px;
  }
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max220};
    width: ${SIZE.max220};
  }
`;
